import { Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export type HelperTextDialogData = {
    helperText: string;
};

@Component({
    imports: [MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule, ReactiveFormsModule],
    template: `
        <h1 mat-dialog-title>Helper Text</h1>

        <div mat-dialog-content id="content">
            <mat-form-field>
                <mat-label>Helper Text</mat-label>
                <textarea matInput [formControl]="dialogControl"></textarea>
                @if (dialogControl.hasError('required')) {
                    <mat-error>Required</mat-error>
                }
                @if (dialogControl.hasError('maxlength')) {
                    <mat-error>Maximum 150 characters</mat-error>
                }
            </mat-form-field>
        </div>

        <div mat-dialog-actions id="actions">
            <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="onSave()"
                [disabled]="!dialogControl.valid">
                Save
            </button>
            <button mat-stroked-button color="black" (click)="onCancel()" type="button">Cancel</button>
        </div>
    `,
    styles: `
        #content {
            mat-form-field {
                width: 100%;
            }
        }
        #actions {
            justify-content: flex-end;
            border-top: solid 1px var(--r1-light-gray);
        }
    `,
})
export class HelperTextDialogComponent {
    readonly #fb = inject(NonNullableFormBuilder);
    readonly #dialogRef = inject<MatDialogRef<HelperTextDialogComponent>>(MatDialogRef);
    readonly #data = inject<HelperTextDialogData>(MAT_DIALOG_DATA);

    protected dialogControl = this.#fb.control(this.#data.helperText, [Validators.maxLength(150)]);

    protected onSave() {
        this.#dialogRef.close(this.dialogControl.getRawValue());
    }

    protected onCancel() {
        this.#dialogRef.close();
    }
}
